import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function JobTrackerSkeleton({ isDarkMode }) {
    const cardCls = `rounded-2xl border shadow-sm ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200"}`;
    const dividerColor = isDarkMode ? "#334155" : "#e2e8f0";
    const baseColor = isDarkMode ? "#334155" : "#e2e8f0";
    const highlightColor = isDarkMode ? "#475569" : "#f1f5f9";

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            <div className="p-4 md:p-6">
                {/* Desktop row layout */}
                {Array.from({ length: 6 }).map((_, i) => (
                    <div
                        key={i}
                        className="hidden md:grid grid-cols-[4fr_2fr_2fr_2fr_2fr_2fr_2fr_1fr] gap-4 items-center px-6 py-4 border-b"
                        style={{ borderColor: dividerColor }}
                    >
                        <Skeleton height={16} />
                        <Skeleton height={16} />
                        <Skeleton height={16} />
                        <Skeleton height={16} />
                        <Skeleton height={28} borderRadius={8} />
                        <Skeleton height={28} borderRadius={8} />
                        <Skeleton height={28} borderRadius={8} />
                        <Skeleton height={16} />
                    </div>
                ))}

                {/* Mobile stacked cards */}
                <div className="md:hidden space-y-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                        <div key={i} className={`${cardCls} p-4`}>
                            <Skeleton width="65%" height={18} />
                            <Skeleton width="45%" height={13} className="mt-2" />
                            <Skeleton width="40%" height={13} className="mt-1" />
                            <div className="mt-3 flex gap-2">
                                <Skeleton width={96} height={30} borderRadius={8} />
                                <Skeleton width={96} height={30} borderRadius={8} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </SkeletonTheme>
    );
}
